import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Dialog,
  DialogContent,
  //DialogTitle,
  useMediaQuery,
  Typography,
  useTheme,
  Grid,
} from "@mui/material";

const ShowHCPQRCode = (props) => {
  const { organizationLogo, popupContentOnly = false, onCancel = null } = props;
  const [showQrCodePopup, setShowQrCodePopup] = useState(false);
  const theme = useTheme();
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const matches = useMediaQuery(theme.breakpoints.down("lg"));

  const qrCode = () => {
    return (
      <Grid
        width={{ width: matches ? "20%" : undefined, cursor: "pointer" }}
        item
        sm={1}
        className="float"
        onClick={() => setShowQrCodePopup(!showQrCodePopup)}
      >
        <Typography
          variant="h1LatoBlack"
          component={"div"}
          sx={{
            fontSize: matches ? "12px" : "18px",
            color: "#093d4c",
            letterSpacing: "0.70px",
            lineHeight: matches ? "0.9rem" : "1.4rem",
            textAlign: "center",
            pointerEvents: "auto",
          }}
        >
          Share Rx Savings! <br />
          <img
            src={organizationLogo?.relatedOrganizationQrBase64}
            style={{ width: "90%", height: "90%", paddingTop: "10px" }}
            alt="qr-code"
            className="qr-code"
          />
        </Typography>
      </Grid>
    );
  };

  const popupContent = () => {
    return (
      <DialogContent>
        <Grid sx={{ display: matches ? "grid" : "contents" }} item sm={1}>
          <Typography
            variant="h1LatoBlack"
            component={"div"}
            sx={{
              fontSize: matches ? "16px" : "18px",
              color: "#093d4c",
              letterSpacing: "0.70px",
              lineHeight: matches ? "0.9rem" : "1.4rem",
              textAlign: "center",
              pointerEvents: "auto",
            }}
          >
            Have patient scan QR code to save! <br />
            <img
              src={organizationLogo?.relatedOrganizationQrBase64}
              style={{
                width: "90%",
                height: "90%",
                paddingBottom: "15px",
                paddingTop: "25px",
              }}
              alt="qr-code"
              className="qr-code"
            />
          </Typography>
          <Grid sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              sx={{
                height: "40px",
                minWidth: matchesMinWidth ? 100 : 300,
              }}
              variant="large"
              onClick={() => {
                setShowQrCodePopup(false);
                onCancel && onCancel();
              }}
            >
              OK
            </Button>
          </Grid>
        </Grid>{" "}
      </DialogContent>
    );
  };

  return (
    <>
      {popupContentOnly &&
        organizationLogo?.relatedOrganizationQrBase64 &&
        popupContent()}
      {!popupContentOnly && organizationLogo?.relatedOrganizationQrBase64 && (
        <>
          {organizationLogo?.relatedOrganizationQrBase64 && qrCode()}
          {showQrCodePopup && (
            <Dialog
              fullWidth={true}
              maxWidth={"sm"}
              onClose={() => setShowQrCodePopup(false)}
              open={showQrCodePopup}
              className="app-dialog"
            >
              {popupContent()}
            </Dialog>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationLogo: state.organizationLogo.data,
  };
};

export default connect(mapStateToProps)(ShowHCPQRCode);
